import { render } from "./PropertyList.vue?vue&type=template&id=b87a6e80&ts=true"
import script from "./PropertyList.vue?vue&type=script&lang=ts"
export * from "./PropertyList.vue?vue&type=script&lang=ts"

import "./PropertyList.vue?vue&type=style&index=0&id=b87a6e80&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__